import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** March 2026 toolkit */
export const anxietyToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.ANXIETY,
  iFrameSrcUrl: '/anxiety',
  micrositeUrl: 'anxiety',
  title: {
    id: 'anxietyToolkit.title',
    defaultMessage: 'Coping with Anxiety',
    description: 'Microsite page title',
  },
  featureFlag: 'isAnxietyToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/managing-anxiety-tools-and-support',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202603 anxiety',
  trackUTMParams: {
    utm_campaign: 'copingwithanxiety202603',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'copingwithanxiety',
  },
  shouldHideForInternational: true,
}
